export default __webpack_public_path__ + "static/media/menuGroupe.132ffe38.svg";